function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { moduleSelector } from "./module.js";
export var signingOrderByIdSelector = function signingOrderByIdSelector(orderId) {
  return function (state) {
    var signingOrder = orderId === 'create' ? state.create : state.orders.find(function (o) {
      return o.id === orderId;
    });
    return signingOrder;
  };
};
export var defaultSignatureMethodsSelector = function defaultSignatureMethodsSelector(orderId, signerId) {
  return createSelector(moduleSelector, signerSignMechanismSelector(orderId, signerId), function (module, signerMechanism) {
    var _module$settings, _module$settings$sign, _module$settings$sign2, _module$settings2, _module$settings2$sig;
    var mechanism = signerMechanism !== null && signerMechanism !== void 0 ? signerMechanism : (_module$settings = module.settings) === null || _module$settings === void 0 ? void 0 : (_module$settings$sign = _module$settings.signature) === null || _module$settings$sign === void 0 ? void 0 : _module$settings$sign.mechanism;
    var methods = (_module$settings$sign2 = (_module$settings2 = module.settings) === null || _module$settings2 === void 0 ? void 0 : (_module$settings2$sig = _module$settings2.signature) === null || _module$settings2$sig === void 0 ? void 0 : _module$settings2$sig.defaultSignatureMethods) !== null && _module$settings$sign2 !== void 0 ? _module$settings$sign2 : [];
    if (methods.length > 0) {
      if (mechanism !== 'mixed' && mechanism !== 'choose_every_time') {
        methods = methods.filter(function (m) {
          return m.includes(mechanism);
        });
      }
      return methods.map(function (s) {
        return {
          signMechanism: s.split('.')[0],
          idp: s.split('.')[1]
        };
      });
    }
    return [];
  });
};
export var defaultRecipientLanguageSelector = function defaultRecipientLanguageSelector(orderId) {
  return createSelector(availableLanguagesSelector(orderId), moduleSelector, function (availableLanguages, module) {
    var _module$settings3, _module$settings3$sig;
    var defaultLanguage = (_module$settings3 = module.settings) === null || _module$settings3 === void 0 ? void 0 : (_module$settings3$sig = _module$settings3.signature) === null || _module$settings3$sig === void 0 ? void 0 : _module$settings3$sig.defaultRecipientLanguage;
    if (!defaultLanguage || defaultLanguage === '') {
      defaultLanguage = module === null || module === void 0 ? void 0 : module.language;
    }
    if (availableLanguages.length < 1 || availableLanguages.includes(defaultLanguage)) {
      return defaultLanguage;
    } else if (availableLanguages.includes('nb') && defaultLanguage === 'no') {
      return 'nb';
    } else if (availableLanguages.includes('no') && defaultLanguage === 'nb') {
      return 'no';
    } else if (availableLanguages.includes('en')) {
      return 'en';
    } else {
      return availableLanguages[0];
    }
  });
};
export var availableLanguagesSelector = function availableLanguagesSelector(orderId) {
  return createSelector(signingOrderByIdSelector(orderId), moduleSelector, function (order, module) {
    var orderStack = order.data.advanced.stack;
    var stackSettings = module.stacks[orderStack];
    return stackSettings.languages || [];
  });
};
export var allowShareSelector = function allowShareSelector(state, orderId, signerId) {
  var _signer$data$signatur;
  var order = orderId === 'create' ? state.create : state.orders.find(function (o) {
    return o.id === orderId;
  });
  var signer = order.data.signers.find(function (s) {
    return s.id === signerId;
  });
  var uiFlag = order.data.uiFeatures.showShare;

  // Check with UI features
  if (uiFlag === 'enabled_with_email' && !signer.data.email) {
    return false;
  }
  if (uiFlag === 'enabled_with_email_and_sms' && (!signer.data.email || !signer.data.mobileNumber)) {
    return false;
  }

  // Special case for blue stack. Allow if mobile is filled.
  if (order.data.advanced.stack === 'blue' && ((_signer$data$signatur = signer.data.signatureMethods) === null || _signer$data$signatur === void 0 ? void 0 : _signer$data$signatur.length) === 1 && signer.data.signatureMethods[0].idp === 'handwritten' && !signer.data.mobileNumber) {
    return false;
  }
  return true;
};
export var allowEmailNotificationSelector = function allowEmailNotificationSelector(state, orderId, signerId) {
  var order = orderId === 'create' ? state.create : state.orders.find(function (o) {
    return o.id === orderId;
  });
  var signer = order.data.signers.find(function (s) {
    return s.id === signerId;
  });
  return !!signer.data.email;
};
export var emailNotificationStateSelector = function emailNotificationStateSelector(state, orderId, signerId) {
  var order = orderId === 'create' ? state.create : state.orders.find(function (o) {
    return o.id === orderId;
  });
  var signer = order.data.signers.find(function (s) {
    return s.id === signerId;
  });
  return signer.data.emailNotification;
};
export var smsNotificationStateSelector = function smsNotificationStateSelector(state, orderId, signerId) {
  var order = orderId === 'create' ? state.create : state.orders.find(function (o) {
    return o.id === orderId;
  });
  var signer = order.data.signers.find(function (s) {
    return s.id === signerId;
  });
  return signer.data.smsNotification;
};
export var pkiIsSelectedInOrderSelector = function pkiIsSelectedInOrderSelector(orderId) {
  return createSelector(signingOrderByIdSelector(orderId), function (order) {
    var _order$data$signers;
    return Boolean((_order$data$signers = order.data.signers) === null || _order$data$signers === void 0 ? void 0 : _order$data$signers.find(function (signer) {
      var _signer$data$signatur2;
      return (_signer$data$signatur2 = signer.data.signatureMethods) === null || _signer$data$signatur2 === void 0 ? void 0 : _signer$data$signatur2.find(function (signatureMethod) {
        return signatureMethod.signMechanism === 'pki_signature';
      });
    }));
  });
};
export var signOrderRecipientsSelector = function signOrderRecipientsSelector(orderId) {
  return createSelector(signingOrderByIdSelector(orderId), function (order) {
    return order.data.signers;
  });
};
export var signingOrderAvailableSigningMethods = function signingOrderAvailableSigningMethods(orderId) {
  return createSelector(moduleSelector, signingOrderByIdSelector(orderId), function (module, signingOrder) {
    var stack = signingOrder.data.advanced.stack;
    var signMechanismSetting = signingOrder.data.uiFeatures.signMechanismSetting;
    var signMechanisms = module.stacks[stack].signMechanisms;
    var orderSignMechanisms = signMechanismSetting === 'choose_every_time' ? signMechanisms : _defineProperty({}, signMechanismSetting, signMechanisms[signMechanismSetting]);
    return orderSignMechanisms;
  });
};
export var signingOrderSignMechanismSelector = function signingOrderSignMechanismSelector(orderId) {
  return createSelector(signingOrderByIdSelector(orderId), function (order) {
    var _order$data$signers2;
    return (_order$data$signers2 = order.data.signers) === null || _order$data$signers2 === void 0 ? void 0 : _order$data$signers2.reduce(function (signingOrderSignMechanism, currSigner) {
      var _currSigner$data$sign;
      if (signingOrderSignMechanism === 'mixed') {
        return signingOrderSignMechanism;
      }
      var currSignerSignMechanism = (_currSigner$data$sign = currSigner.data.signatureMethods) === null || _currSigner$data$sign === void 0 ? void 0 : _currSigner$data$sign.reduce(function (signerSignMechanism, signMethod) {
        if (signerSignMechanism === null) {
          return signMethod.signMechanism;
        } else if (signMethod.signMechanism !== signerSignMechanism) {
          return 'mixed';
        }
        return signerSignMechanism;
      }, null);
      if (currSignerSignMechanism === null) {
        return signingOrderSignMechanism;
      } else if (signingOrderSignMechanism === null) {
        return currSignerSignMechanism;
      } else if (currSignerSignMechanism !== signingOrderSignMechanism) {
        return 'mixed';
      }
      return signingOrderSignMechanism;
    }, null);
  });
};
export var signingOrderSignerSelector = function signingOrderSignerSelector(orderId, signerId) {
  return createSelector(signingOrderByIdSelector(orderId), function (signingOrder) {
    return signingOrder.data.signers.find(function (signer) {
      return signer.id === signerId;
    });
  });
};
export var signingOrderErrorSignerSelector = function signingOrderErrorSignerSelector(orderId, signerId) {
  return createSelector(signingOrderSignerSelector(orderId, signerId), function (signer) {
    return signer.error !== undefined ? signer : null;
  });
};
export var signerSignMechanismSelector = function signerSignMechanismSelector(orderId, signerId) {
  return createSelector(signingOrderSignerSelector(orderId, signerId), function (signer) {
    var _signer$data$signatur3;
    var signerSignMechanism = (_signer$data$signatur3 = signer.data.signatureMethods) === null || _signer$data$signatur3 === void 0 ? void 0 : _signer$data$signatur3.reduce(function (signMechanism, signMethod) {
      if (signMechanism === 'mixed') {
        return signMechanism;
      }
      if (signMechanism === null) {
        return signMethod.signMechanism;
      } else if (signMethod.signMechanism !== signMechanism) {
        return 'mixed';
      }
      return signMechanism;
    }, null);
    return signerSignMechanism;
  });
};
export default {
  allowShareSelector: allowShareSelector,
  allowEmailNotificationSelector: allowEmailNotificationSelector,
  emailNotificationStateSelector: emailNotificationStateSelector,
  smsNotificationStateSelector: smsNotificationStateSelector,
  pkiIsSelectedInOrderSelector: pkiIsSelectedInOrderSelector,
  signOrderRecipientsSelector: signOrderRecipientsSelector,
  signingOrderSignMechanismSelector: signingOrderSignMechanismSelector,
  signingOrderAvailableSigningMethods: signingOrderAvailableSigningMethods,
  signerSignMechanismSelector: signerSignMechanismSelector,
  defaultRecipientLanguageSelector: defaultRecipientLanguageSelector,
  defaultSignatureMethodsSelector: defaultSignatureMethodsSelector
};